import { DTO__grid2d_generation } from '@shared/dto/grid2d/DTO__grid2d_generation';
import { GRID2D_GALLERY__image_master } from '../grid2d_gallery/GRID2D_GALLERY__image_master';
import { GRID2D_GALLERY_GENERATION__image_neigbours } from './GRID2D_GALLERY_GENERATION__image_neigbours';

interface PROPS {
  grid2d: DTO__grid2d_generation;
}

export function GRID2D_GALLERY__fixed_generation({ grid2d }: PROPS) {
  return (
    <div className="relative size-full bg-component">
      <GRID2D_GALLERY__image_master />

      <GRID2D_GALLERY_GENERATION__image_neigbours {...{ grid2d }} />
    </div>
  );
}
